const THREE = require("three");
THREE.BufferGeometryUtils = require("./BufferGeometryUtils.js")(THREE);
const UTILS = require("./utils.js");
const config = require("../config.js");
const SimplexNoise = require("simplex-noise");
const easing = require("./easing.js").easing;
let isClient = typeof location != "undefined";
const BIOMES = {
  GRASS: {
    ind: 0,
    power: 2100,
    slopeSton: 0.8,
    genTer: function (Q, R, S, T) {
      let U = Q._sample(R, S, 300);
      U = Math.floor(U * 4) / 4;
      let V = T[this.ind] * 1;
      return U * 18 * T[this.ind] * Q.sizeMlt + V;
    },
  },
  MOUNTAIN: {
    ind: 1,
    power: 1900,
    genTer: function (Q, R, S, T) {
      let U = 0.4 + Q._sample(R, S, 200) * 0.3;
      let V = 1 - Math.abs(U - Q._sample(R, S, 500)) * 2;
      let W = 0.4 + Q._sample(R, S, 400) * 1.4;
      return Math.abs(V * W * (Q.mntMlt * 220) * T[this.ind]) * Q.sizeMlt;
    },
  },
  SNOW: {
    ind: 2,
    forceCol: "SNOW",
    slopeSton: 0.75,
    earthLoc: 0.8,
    power: 1000,
    genTer: function (Q, R, S, T) {
      let U = Q._sample(R, S, 300);
      U = Math.floor(U * 3) / 3;
      let V = T[this.ind] * 90;
      return U * 15 * T[this.ind] * Q.sizeMlt + V;
    },
  },
  HILLS: {
    ind: 3,
    power: 2100,
    slopeSton: 0.7,
    forceCol: "GRASS",
    genTer: function (Q, R, S, T) {
      let U = 1 - Q._sample(R, S, 2000) * 2;
      let V = 0.4 + Q._sample(R, S, 400) * 0.4;
      return Math.abs(U * V * (Q.mntMlt * -100) * T[this.ind]) * Q.sizeMlt;
    },
  },
};
const F = Object.keys(BIOMES).length;
var G = [];
for (var H in BIOMES) {
  if (BIOMES.hasOwnProperty(H)) {
    G.push(H);
  }
}
const I = {
  TREE: {
    max: 2000,
    sample: 300,
    maxHeight: 230,
    biomes: ["GRASS", "SNOW", "HILLS"],
    biomeCols: {
      SNOW: ["#484d35", "#4d4b35", "#5c5a3c"],
    },
    biomeCoats: {
      SNOW: "#e8fdff",
    },
    check: function (Q, R) {
      return (
        Q != "MOUNTAIN" &&
        R != "MOUNTAIN" &&
        Q != "DIRT" &&
        R != "DIRT" &&
        Q != "SAND" &&
        R != "SAND"
      );
    },
    rate: function () {
      return 0.18;
    },
  },
  STUMP: {
    max: 200,
    sample: 300,
    maxHeight: 600,
    biomes: ["GRASS", "SNOW", "HILLS"],
    check: function (Q, R) {
      return Q != "MOUNTAIN" && R != "MOUNTAIN";
    },
    rate: function () {
      return 0.02;
    },
  },
  LOOT: {
    max: 50,
    sample: 300,
    biomes: ["GRASS", "SNOW", "HILLS"],
    check: function (Q, R) {
      return Q != "MOUNTAIN" && R != "MOUNTAIN";
    },
    rate: function () {
      return 0.02;
    },
  },
  ROCK: {
    max: 500,
    sample: 300,
    maxHeight: 400,
    biomes: ["GRASS", "SNOW", "HILLS"],
    biomeCoats: {
      SNOW: "#e8fdff",
    },
    check: function () {
      return true;
    },
    rate: function () {
      return 0.075;
    },
  },
  BUSH: {
    sample: 400,
    maxHeight: 200,
    client: true,
    biomes: ["GRASS", "SNOW", "HILLS"],
    biomeCols: {
      SNOW: ["#484d35"],
    },
    biomeCoats: {
      SNOW: "#e8fdff",
    },
    check: function (Q, R) {
      return Q != "MOUNTAIN" && R != "MOUNTAIN";
    },
    rate: function () {
      return 0.05;
    },
  },
  GRASS: {
    sample: 400,
    maxHeight: 200,
    countM: 1,
    client: true,
    biomes: ["GRASS", "HILLS"],
    biomeCols: {
      GRASS: ["#4d5928"],
      HILLS: ["#4d5928"],
    },
    check: function (Q, R) {
      return false;
    },
  },
};
const J = (Q) =>
  Q.replace(
    /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    (R, S, T, U) => "#" + S + S + T + T + U + U,
  )
    .substring(1)
    .match(/.{2}/g)
    .map((R) => parseInt(R, 16));
var K = new THREE.Vector3();
var L = new THREE.Vector3();
var M = new THREE.Vector3();
class Terrain extends THREE.Object3D {
  static fromConfig(terrainConfig) {
    return new Terrain(
      terrainConfig.terrainSeed,
      terrainConfig.terrainWidth,
      terrainConfig.terrainHeight,
      terrainConfig.sizeMlt,
      terrainConfig.terrainMntMlt,
      terrainConfig.terrainDrtCol,
      terrainConfig.terrainGrsCol,
      terrainConfig.terrainMntCol,
      terrainConfig.terrainSnwCol,
      terrainConfig.terrainSndCol,
      terrainConfig.terrainTSeed,
      terrainConfig.terrainEase,
    );
  }
  constructor(
    seed,
    width,
    height,
    sizeMlt,
    mntMlt,
    dirtColor,
    grassColor,
    mountainColor,
    a1,
    a2,
    a3,
    a4,
  ) {
    function a5(ap, aq, ar, as) {
      var at = ar + "_" + as;
      ai[at] ||= [];
      ai[at].push({
        i: ap,
        c: aq,
      });
    }
    super();
    5.7;
    this.name = "Terrain";
    this.sizeMlt = 5.7;
    this.sizeX = UTILS.limitMM(
      width,
      config.minTerrainSize,
      config.maxTerrainSize,
    );
    this.sizeY = UTILS.limitMM(
      height,
      config.minTerrainSize,
      config.maxTerrainSize,
    );
    this.edgeSize = 500;
    this.mntMlt = UTILS.limitMM(
      mntMlt,
      config.minMountainMlt,
      config.maxMountainMlt,
    );
    this.COLORS = {
      DIRT: J(dirtColor || "#8c6835"),
      GRASS: J(grassColor || "#4a6904"),
      MOUNTAIN: J(mountainColor || "#a0a0a0"),
      SAND: J(a2 || "#967f51"),
      SNOW: J(a1 || "#e8fdff"),
      HILLS: J(grassColor || "#4a6904"),
    };
    this.ease = easing[Terrain.EASE_LIST[a4] || "easeInOutQuint"];
    this.MAP_OBJS = I;
    this.BIOME_INDEXES = G;
    this.simplex = new SimplexNoise(seed);
    this.simplexObjs = new SimplexNoise(a3);
    this.sampleIndex3D = 0;
    this.genObjs = !!a3;
    this.objPos = {};
    for (var a6 in I) {
      if (I.hasOwnProperty(a6)) {
        this.objPos[a6] = [];
      }
    }
    let a7 = Math.floor(this.sizeX / 25);
    let a8 = Math.floor(this.sizeY / 25);
    this.xSegmentCount = a7;
    this.ySegmentCount = a8;
    let a9 = this.sizeX / a7;
    let aa = this.sizeY / a8;
    this.xSegmentSize = a9;
    this.ySegmentSize = aa;
    let ab = new THREE.BufferGeometry();
    let ac = a7 * a8 * 6;
    let ad = new THREE.BufferAttribute(new Float32Array(ac * 3), 3);
    ab.setAttribute("position", ad);
    let ae = new THREE.BufferAttribute(new Uint8Array(ac * 3), 3, true);
    ab.setAttribute("color", ae);
    this.vertPositions = ad;
    this.terrainPoints = (a7 + 1) * (a8 + 1);
    this.terrainHeights = new Float32Array(this.terrainPoints);
    this.biomeSegs = {};
    for (let ap = 0; ap < a7 + 1; ap++) {
      for (let aq = 0; aq < a8 + 1; aq++) {
        let ar = ap + aq * (a7 + 1);
        let as = this._vertPos(ap, a9, this.sizeX);
        let at = this._vertPos(aq, aa, this.sizeY);
        let [au, av] = this.evaluate(as, at);
        this.terrainHeights[ar] = au;
        var af = 0;
        var ag = 0;
        for (var ah in BIOMES) {
          if (BIOMES.hasOwnProperty(ah) && av[BIOMES[ah].ind] > ag) {
            ag = av[BIOMES[ah].ind];
            af = BIOMES[ah].ind;
          }
        }
        this.biomeSegs[ap + "_" + aq] = {
          i: af,
        };
      }
    }
    var ai = {};
    for (let aw = 0; aw < a7; aw++) {
      for (let ax = 0; ax < a8; ax++) {
        let ay = (aw + ax * a7) * 6;
        let az = this._vertPos(aw, a9, this.sizeX);
        let aA = this._vertPos(ax, aa, this.sizeY);
        let aB = [az, aA, this.terrainHeight(aw, ax)];
        let aC = [az + a9, aA, this.terrainHeight(aw + 1, ax)];
        let aD = [az + a9, aA + aa, this.terrainHeight(aw + 1, ax + 1)];
        let aE = [az, aA + aa, this.terrainHeight(aw, ax + 1)];
        ad.setXYZ(ay, ...aB);
        ad.setXYZ(ay + 1, ...aC);
        ad.setXYZ(ay + 2, ...aD);
        ad.setXYZ(ay + 3, ...aD);
        ad.setXYZ(ay + 4, ...aE);
        ad.setXYZ(ay + 5, ...aB);
        var aj = this.biomeSegs[aw + "_" + ax];
        let aF = this._centroid3D(aB, aC, aD);
        let aG = this._centroid3D(aD, aE, aB);
        let aH = this._normal3D(aB, aC, aD);
        this._normal3D(aD, aE, aB);
        aj.c = this.evaluateColor(aF, aH, aj.i);
        var ak = Math.max(aF[2], aG[2]);
        if (this.genObjs) {
          for (var al in I) {
            if (
              I.hasOwnProperty(al) &&
              I[al].biomes.indexOf(G[aj.i]) >= 0 &&
              (!I[al].maxHeight || !(I[al].maxHeight <= ak)) &&
              (!I[al].client || isClient) &&
              I[al].check(aj.c)
            ) {
              this.evaluateObj(aF, aB, aC, aD, aj.i, al);
              this.evaluateObj(aG, aD, aE, aB, aj.i, al);
            }
          }
        }
        if (isClient) {
          let aI = this.calcAOWeight(aw, ax);
          let aJ = this.calcAOWeight(aw + 1, ax);
          let aK = this.calcAOWeight(aw + 1, ax + 1);
          let aL = this.calcAOWeight(aw, ax + 1);
          var am = this.COLORS[aj.c];
          a5(ay, this._weightColor(am, aI), aw - 0.5, ax - 0.5);
          a5(ay + 1, this._weightColor(am, aJ), aw + 0.5, ax - 0.5);
          a5(ay + 2, this._weightColor(am, aK), aw + 0.5, ax + 0.5);
          a5(ay + 3, this._weightColor(am, aK), aw + 0.5, ax + 0.5);
          a5(ay + 4, this._weightColor(am, aL), aw - 0.5, ax + 0.5);
          a5(ay + 5, this._weightColor(am, aI), aw - 0.5, ax - 0.5);
        }
      }
    }
    if (isClient) {
      for (var a6 in ai) {
        if (ai.hasOwnProperty(a6)) {
          am = [0, 0, 0];
          for (var an = 0; an < ai[a6].length; ++an) {
            ae.setXYZ(ai[a6][an].i, ...ai[a6][an].c);
          }
        }
      }
    }
    ai = null;
    this.biomeSegs = null;
    if (isClient) {
      ab = THREE.BufferGeometryUtils.mergeVertices(ab);
      ab.computeVertexNormals(true);
      ab.computeFaceNormals();
      var ao = new THREE.StrippedLambertMaterial({
        color: 9211020,
        flatShading: false,
        vertexColors: THREE.VertexColors,
      });
      this.baseMesh = new THREE.Mesh(ab, ao);
      this.baseMesh.receiveShadow = true;
      this.baseMesh.scale.set(5.7, 5.7, 1);
      this.add(this.baseMesh);
    }
    this._raycastRay = new THREE.Ray();
    this._raycastTriA = new THREE.Vector3();
    this._raycastTriB = new THREE.Vector3();
    this._raycastTriC = new THREE.Vector3();
    this._raycastTriangle = new THREE.Triangle();
    this._raycastNormal = new THREE.Vector3();
    this._raycastTarget = new THREE.Vector3();
    this._raycastClosestTarget = new THREE.Vector3();
  }
  generateTexture(Q, R) {
    var S = document.createElement("canvas");
    S.width = Q;
    S.height = R;
    var T = S.getContext("2d");
    T.fillStyle = "#ffffff";
    T.fillRect(0, 0, Q, R);
    T.fillStyle = "#000000";
    T.fillRect(0, 0, Q / 2, R / 2);
    return S;
  }
  evaluateObj(Q, R, S, T, U, V) {
    if (!(Q[2] <= -120)) {
      var W = I[V];
      if (!W.max || !(this.objPos[V].length >= W.max)) {
        let a1 = this._sample3D(Q[0], Q[1], W.sample);
        var X = W.rate ? W.rate(U) : null;
        if (X == null || a1 > 1 - X || a1 < X) {
          var Y;
          for (
            var Z = Math.floor(a1 * (W.countM || 1)) || 1, a0 = 0;
            a0 < Z;
            a0++
          ) {
            Y = this.randomInTriangle(R, S, T, Q[0], Q[1]);
            this.objPos[V].push([
              Y.x * this.sizeMlt,
              Y.z,
              -Y.y * this.sizeMlt,
              U,
            ]);
          }
        }
      }
    }
  }
  randomInTriangle(Q, R, S, T, U) {
    Q = K.set(...Q);
    R = L.set(...R);
    S = M.set(...S);
    var V = this._sample3D(T, U, 400);
    var W = Math.sqrt(this._sample3D(T, U, 500));
    return Q.clone()
      .multiplyScalar(1 - W)
      .add(R.clone().multiplyScalar(W * (1 - V)))
      .add(S.clone().multiplyScalar(V * W));
  }
  terrainIndex(Q, R) {
    let S = Q + R * (this.xSegmentCount + 1);
    if (S < 0 || S >= this.terrainHeights.length) {
      return 0;
    } else {
      return S;
    }
  }
  terrainHeight(Q, R) {
    return this.terrainHeights[this.terrainIndex(Q, R)];
  }
  calcAOWeight(Q, R) {
    let S = this._vertPos(Q, this.xSegmentSize, this.sizeX);
    let T = this._vertPos(R, this.ySegmentSize, this.sizeY);
    let U = this._topAngleOnTerrain(
      S - this.xSegmentSize,
      this.terrainHeight(Q - 1, R),
      S,
      this.terrainHeight(Q, R),
      S + this.xSegmentSize,
      this.terrainHeight(Q + 1, R),
    );
    let V = this._topAngleOnTerrain(
      T - this.xSegmentSize,
      this.terrainHeight(Q, R - 1),
      T,
      this.terrainHeight(Q, R),
      T + this.ySegmentSize,
      this.terrainHeight(Q, R + 1),
    );
    let W = Math.PI;
    let X = 1 - (1 - Math.max(W - U, 0) / W) * (1 - Math.max(W - V, 0) / W);
    if (X >= 0.5) {
      X = 0.65;
    } else if (X >= 0.2) {
      X = 0.3;
    } else if (X >= 0.1) {
      X = 0.25;
    }
    return X;
  }
  heightAt(Q, R) {
    Q /= this.sizeMlt;
    R /= this.sizeMlt;
    let S = Math.floor(this._worldToLocal(Q, this.sizeX, this.xSegmentSize));
    let T = Math.floor(this._worldToLocal(R, this.sizeY, this.ySegmentSize));
    let U = O(this._worldToLocal(Q), this.xSegmentSize) / this.xSegmentSize;
    let V = O(this._worldToLocal(R), this.ySegmentSize) / this.ySegmentSize;
    let W = P(this.terrainHeight(S, T), this.terrainHeight(S, T + 1), V);
    let X = P(
      this.terrainHeight(S + 1, T),
      this.terrainHeight(S + 1, T + 1),
      V,
    );
    return P(W, X, U);
  }
  _worldToLocal(Q, R, S) {
    return (Q + R / 2) / S;
  }
  raycast(Q, R, S, T, U, V, W = false) {
    Q /= this.sizeMlt;
    R /= this.sizeMlt;
    T /= this.sizeMlt;
    U /= this.sizeMlt;
    let X = Math.sqrt(T * T + U * U + V * V);
    this._raycastRay.origin.set(Q, R, S);
    this._raycastRay.direction.set(T, U, V);
    let Y;
    let Z;
    let a0;
    let a1 = this._worldToLocal(Q, this.sizeX, this.xSegmentSize);
    let a2 = this._worldToLocal(R, this.sizeY, this.ySegmentSize);
    let a3 = a1 + T / this.xSegmentSize;
    let a4 = a2 + U / this.ySegmentSize;
    let a5 = Math.abs(a3 - a1);
    let a6 = Math.abs(a4 - a2);
    let a7 = Math.floor(a1);
    let a8 = Math.floor(a2);
    let a9 = 1;
    if (a5 == 0) {
      Y = 0;
      a0 = Number.POSITIVE_INFINITY;
    } else if (a3 > a1) {
      Y = 1;
      a9 += Math.floor(a3) - a7;
      a0 = (Math.floor(a1) + 1 - a1) * a6;
    } else {
      Y = -1;
      a9 += a7 - Math.floor(a3);
      a0 = (a1 - Math.floor(a1)) * a6;
    }
    if (a6 == 0) {
      Z = 0;
      a0 -= Number.POSITIVE_INFINITY;
    } else if (a4 > a2) {
      Z = 1;
      a9 += Math.floor(a4) - a8;
      a0 -= (Math.floor(a2) + 1 - a2) * a5;
    } else {
      Z = -1;
      a9 += a8 - Math.floor(a4);
      a0 -= (a2 - Math.floor(a2)) * a5;
    }
    for (; a9 > 0; a9--) {
      if (this._raycastVisit(a7, a8, Q, R, S, T, U, V, X, W)) {
        let aa = this._raycastClosestTarget;
        aa.x *= this.sizeMlt;
        aa.y *= this.sizeMlt;
        return aa;
      }
      if (a0 > 0) {
        a8 += Z;
        a0 -= a5;
      } else {
        a7 += Y;
        a0 += a6;
      }
    }
  }
  _raycastVisit(Q, R, S, T, U, V, W, X, Y, Z) {
    let a0 = Q + R * this.xSegmentCount;
    let a1 = Number.POSITIVE_INFINITY;
    let a2 = false;
    for (let a3, a4 = 0; a4 < 2; a4++) {
      a3 = a0 * 6 + a4 * 3;
      this._raycastTriA.set(
        this.vertPositions.getX(a3),
        this.vertPositions.getY(a3),
        this.vertPositions.getZ(a3),
      );
      this._raycastTriB.set(
        this.vertPositions.getX(a3 + 1),
        this.vertPositions.getY(a3 + 1),
        this.vertPositions.getZ(a3 + 1),
      );
      this._raycastTriC.set(
        this.vertPositions.getX(a3 + 2),
        this.vertPositions.getY(a3 + 2),
        this.vertPositions.getZ(a3 + 2),
      );
      let a5 = this._raycastRay.intersectTriangle(
        this._raycastTriA,
        this._raycastTriB,
        this._raycastTriC,
        true,
        this._raycastTarget,
      );
      if (a5) {
        let a6 = a5.distanceTo(this._raycastRay.origin);
        if (a6 < a1 && a6 < Y) {
          a1 = a6;
          a2 = true;
          this._raycastClosestTarget.copy(a5);
          this._raycastTriangle.set(
            this._raycastTriA,
            this._raycastTriB,
            this._raycastTriC,
          );
        }
      }
    }
    if (Z && a2) {
      this._raycastTriangle.getNormal(this._raycastNormal);
    }
    return a2;
  }
  evaluate(Q, R) {
    let S = 0;
    this.sampleIndex = 0;
    this.sizeY;
    let T = [];
    for (let a1 = 0; a1 < F; a1++) {
      var U = BIOMES[G[a1]].power || 1800;
      T.push(this._sample(Q, R, U));
    }
    let V = T.reduce((a2, a3) => a2 + a3, 0);
    T = T.map((a2, a3) => [a3, a2 / V]);
    T = T.sort((a2, a3) => a3[1] - a2[1]);
    let W = {};
    let [X, Y] = T[0];
    W[X] = this._easeTerrain(Y / (Y + T[1][1]));
    for (let a2 = 1; a2 < T.length; a2++) {
      let [a3, a4] = T[a2];
      W[a3] = this._easeTerrain(a4 / (Y + a4));
    }
    for (var Z in BIOMES) {
      if (BIOMES.hasOwnProperty(Z)) {
        S += BIOMES[Z].genTer(this, Q, R, W);
      }
    }
    let a0 =
      this._calcEdgeFade(Q, this.sizeX) * this._calcEdgeFade(R, this.sizeY);
    S *= a0;
    S += (a0 - 1) * 2000;
    if (Math.abs(Q) >= this.sizeX / 2 || Math.abs(R) >= this.sizeY / 2) {
      S = -1000;
    }
    return [S, W];
  }
  evaluateColor(Q, R, S) {
    let T;
    let U = Q[2];
    let V = Math.atan2(Math.abs(R[0]), Math.abs(R[2]));
    let W = Math.atan2(Math.abs(R[1]), Math.abs(R[2]));
    let X = 1 - V / (Math.PI * 2);
    let Y = 1 - W / (Math.PI * 2);
    T = U > 100 ? "MOUNTAIN" : U > 5 ? "GRASS" : "DIRT";
    var Z = BIOMES[G[S]];
    if (Z.forceCol) {
      T = Z.forceCol;
    }
    if (U > 950) {
      T = "SNOW";
    }
    if (U <= -10) {
      T = "SAND";
    } else if (U > 250 || X * Y <= (Z.slopeSton || 0.85)) {
      T = "MOUNTAIN";
    }
    return T;
  }
  _sample(Q, R, S) {
    this.sampleIndex++;
    return (
      this.simplex.noise3D(Q / S, R / S, this.sampleIndex * 10000) / 2 + 0.5
    );
  }
  _sample3D(Q, R, S) {
    this.sampleIndex3D++;
    return (
      this.simplexObjs.noise3D(Q / S, R / S, this.sampleIndex3D * 10000) / 2 +
      0.5
    );
  }
  _easeTerrain(Q) {
    return this.ease(this.ease(Q));
  }
  _calcEdgeFade(Q, R) {
    if (Math.abs(Q) >= R / 2) {
      return 0;
    }
    let S = (Math.abs(Q) - R / 2 + this.edgeSize) / this.edgeSize;
    S = 1 - Math.max(S, 0);
    return easing.easeOutQuint(S);
  }
  _vertPos(Q, R, S) {
    return Q * R - S / 2;
  }
  _avgPos(Q, R) {
    return [(Q[0] + R[0]) / 2, (Q[1] + R[1]) / 2, (Q[2] + R[2]) / 2];
  }
  _centroid3D(Q, R, S) {
    return [
      (Q[0] + R[0] + S[0]) / 3,
      (Q[1] + R[1] + S[1]) / 3,
      (Q[2] + R[2] + S[2]) / 3,
    ];
  }
  _normal3D(Q, R, S) {
    let T = S[0] - R[0];
    let U = S[1] - R[1];
    let V = S[2] - R[2];
    let W = Q[0] - R[0];
    let X = Q[1] - R[1];
    let Y = Q[2] - R[2];
    let Z = U * Y - V * X;
    let a0 = V * W - T * Y;
    let a1 = T * X - U * W;
    let a2 = Math.sqrt(Z * Z + a0 * a0 + a1 + a1);
    return [Z / a2, a0 / a2, a1 / a2];
  }
  _topAngleOnTerrain(Q, R, S, T, U, V) {
    let W = Math.atan2(R - T, Q - S);
    let X = Math.atan2(V - T, U - S);
    if (W < 0) {
      W += Math.PI * 2;
    }
    return W - X;
  }
  _weightColor(Q, R) {
    return Q.map((S) => S * (1 - R));
  }
}
function O(Q, R) {
  return ((Q % R) + R) % R;
}
function P(Q, R, S) {
  return Q * (1 - S) + R * S;
}
Terrain.CONFIG_PROPS = [
  "terrainSeed",
  "terrainTSeed",
  "terrainWidth",
  "terrainHeight",
  "sizeMlt",
  "terrainMntMlt",
  "terrainDrtCol",
  "terrainGrsCol",
  "terrainMntCol",
  "terrainSnwCol",
  "terrainSndCol",
  "terrainEase",
];
Terrain.EASE_LIST = Object.keys(easing);
Terrain.BIOME_LIST = Object.keys(BIOMES);
module.exports = Terrain;
